import { axiosInstance } from "@/config/axiosInstance";

interface CompanyHolidayInput {
  holidayName: string;
  date: Date | string;
  description: string;
  isHalfDay: boolean;
  minimumHours?: number;
}

// CREATE Company Holiday List
export const createCompanyHolidayList =
  (adminKey: string) =>
  (data: { name: string; year: number; holidays: CompanyHolidayInput[] }) =>
    axiosInstance
      .post("/company-holiday/create", data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// EDIT Company Holiday List
export const editCompanyHolidayList =
  (adminKey: string) =>
  (data: {
    id: string;
    name?: string;
    year?: number;
    holidays?: CompanyHolidayInput[];
  }) =>
    axiosInstance
      .post(
        `/company-holiday/edit/${data.id}`,
        {
          name: data.name,
          year: data.year,
          holidays: data.holidays,
        },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// DELETE Company Holiday List
export const deleteCompanyHolidayList =
  (adminKey: string) => (id: string) =>
    axiosInstance
      .post(
        `/company-holiday/delete/${id}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// SET ACTIVE Company Holiday List
export const setActiveCompanyHolidayList =
  (adminKey: string) => (id: string) =>
    axiosInstance
      .post(
        `/company-holiday/set-active/${id}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
